export const CYCLE_DETAILS = 'cycleDetails';
export const GET_CURRENT_CYCLE_DETAILS = `${CYCLE_DETAILS}/GetCycleCurrentDetails`;

